import { useEssentials } from 'hooks/utils/useEssentials'
import { isStore } from 'utils/location'
import { StoreFulfillmentINFStore } from './store-fulfillment-inf-store-level'
import { StoreFulfillmentInfRGD } from './store-fulfillment-inf-rgd'

export const StoreFulfillmentINF = () => {
    const { currentLocation } = useEssentials()
    if (isStore(currentLocation)) {
        return <StoreFulfillmentINFStore />
    } else {
        return <StoreFulfillmentInfRGD />
    }
}
